/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import React from 'react';
// @ts-ignore
import ScrollFadeIn from './../scroll-fade/./scroll-fade';
// @ts-ignore
import HorizontalProductScroller from './../horizontal-product-scroller/./horizontal-product-scroller';
// @ts-ignore
import {MobileBreakpoint} from './../../themes/kent/utilities/constants';
// @ts-ignore
import {GetYoutubeIdFromUrl} from './../../themes/kent/utilities/functions';
// @ts-ignore
import YoutubeBackground from 'react-youtube-background';
// @ts-ignore
import Button from './../button/./button';

interface IState {
  ready:boolean;
  muted:boolean;
  volume:number;
  controls:boolean;
  updateKey:number;
  height:number;
  videoId:any;
  quickCompareActive?:any;
}

interface IProps {
  video?:string;
  height?:string;
  theme?:string;
  title?:string;
  preTitle?:string;
  subtitle?:string;
  description?:string;
  icon?:any;
  textPlacement?:string;
  backgroundTint?:string;
  link?:string;
  buttonText?:string;
  brandedTextImage?:any;
  brandedTextImageMaxWidth?:string;
  decorativeText?:any;
  quickCompareTheme?:any;
  quickCompareCategoryId?:any;
  year?:any;
}

/**
 *
 * Hero component
 * @extends {React.Component<IProps>}
 */
class HosportsVideoHero extends React.Component<IProps> {

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      ready:false,
      updateKey:100,
      muted:true,
      controls:false,
      volume:1,
      height:0,
      videoId:null
    };
  }

  public componentDidMount = async() => {
    const videoId = await GetYoutubeIdFromUrl(this.props.video);
    this.setState({
      videoId:videoId
    });
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
  }

  public isReady = () => {
    this.setState({
      ready:true
    })
  }

  public updateDimensions = () => {
    let height = window.outerHeight;
    this.setState({
      height:height
    })
  }

  public volumeClick = () =>{
    if(this.state.muted){
      this.setState({
        volume:1,
        muted:false,
        controls:true
      })
    } else{
      this.setState({
        volume:0,
        muted:true,
        controls:false
      })
    }
  }

  public componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  public quickCompareClicked=()=>{
    this.setState({
      quickCompareActive:true
    })
  }
  public quickCompareDismissed=()=>{
    this.setState({
      quickCompareActive:false
    })
  }

  public render(): JSX.Element {
    const heightClass = this.props.height && cssClassCoversionDictionary[this.props.height];
    const textPlacementClass = this.props.textPlacement &&  cssClassCoversionDictionary[this.props.textPlacement];
    const color = this.props.theme === 'dark' ? '#fff' : '#000';
    const videoId = this.state.videoId;
    let height = this.state.height;
    let decorativeFontClass = this.props.decorativeText ? "decorative-text" : "";
    if( this.props.height ==  "threeQuarter"){
      height = height*0.75;
    }
    if( this.props.height ==  "half"){
      height = height*0.5;
    }
    if( this.props.height ==  "quarter"){
      height = height*0.25;
    }
    return (
      <ScrollFadeIn>
        <div className={'video-hero-wrapper '+this.state.ready ? 'ready' : ''}>
          {videoId &&
            <YoutubeBackground
              nocookie={true}
              playerOptions={{
                rel:0,
                modestbranding:1,
                controls:0,
                loop:1
              }}
              onPlay={this.isReady}
              videoId={videoId}
              className={'video-player-container'}
              >
              <div className={`video-hero ${ heightClass }`}>
                <div className={`video-hero-content ${ textPlacementClass }`}>
                  <div className="full-width">
                    {this.props.icon &&
                      <div className='video-hero-icon'>
                        <img style={{width:'100%'}} src={this.props.icon}  />
                      </div>
                    }
                    {this.props.preTitle &&
                      <h5 className='video-hero-pre-title uppercase full-width' style={{color:color}}>{this.props.preTitle}</h5>
                    }
                    {this.props.title &&
                      <h1 className={'video-hero-title full-width '+decorativeFontClass} style={{color:color}}>{this.props.title}</h1>
                    }
                    {this.props.brandedTextImage &&
                      <div className="full-width video-hero-branded-text">
                        <img src={this.props.brandedTextImage.src} style={{width:'90%', maxWidth:this.props.brandedTextImageMaxWidth ? this.props.brandedTextImageMaxWidth : 'none'}} />
                      </div>
                    }
                    {this.props.subtitle &&
                      <h5 className='video-hero-subtitle uppercase full-width tiny-padding' style={{color:color}}>{this.props.subtitle}</h5>
                    }
                    {this.props.description &&
                      <p className='video-hero-description' style={{color:color}}>{this.props.description}</p>
                    }
                    {this.props.link && <div className="hero-button">
                      <a href={this.props.link}>
                        <Button text={this.props.buttonText} backgroundColor={'#fff'} color={'#000'} />
                      </a>
                    </div>
                    }
                    {this.props.quickCompareCategoryId &&
                      <span>
                        <span onClick={this.quickCompareClicked}>
                          <Button  text={'Quick Compare'} backgroundColor={'#fff'} color={'#000'} />
                        </span>
                        {this.state.quickCompareActive && <HorizontalProductScroller year={this.props.year} theme={'dark'} showStats={true} active={this.state.quickCompareActive} categoryId={this.props.quickCompareCategoryId} dismissed={this.quickCompareDismissed} />}
                      </span>
                    }
                  </div>
                </div>
                <div className={`video-hero-tint tint ${ this.props.backgroundTint }`} />
              </div>
            </YoutubeBackground>
          }
        </div>
      </ScrollFadeIn>
    );
  }
}

export const cssClassCoversionDictionary = {
  threeQuarter:'three-quarter',
  half:'half',
  quarter:'quarter',
  full:'full',
  centerCenter:'center-center',
  leftCenter:'left-center',
  rightCenter:'right-center',
  bottomLeft:'bottom-left',
  bottomRight:'bottom-right',
  bottomCenter:'bottom-center',
  topLeft:'top-left',
  topRight:'top-right',
  topCenter:'top-center'
};

export default HosportsVideoHero;
